<template lang="pug">
div
  v-row( justify='center' ).mt-12
    h2.rojo--text.font-weight-bold.icono-international.icono-grande.pl-7.pt-5 SOMOS DISTRIBUIDORES
  v-row.justify-center.pb-10
    h3.font-weight-thin EXCLUSIVOS DE LAS MARCAS
  v-row( justify='center' align='center' ).fill-height
    template( v-for='{imagen, vinculo} of Marcas' )
      v-col( cols=12 md=4 )
        v-card(flat tile) 
          v-img(:src='imagen' contain height=160).azul
          v-card-actions
            v-spacer
            v-btn( style='text-transform: none!important' color='rojo' tile target='_blank' :href='vinculo').elevation-0.px-6
              small.white--text Descargar brochure
            v-spacer         
</template>
<script>
export default {
  computed: {
    Marcas(){
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.marcas : { marcas:[] }
    },
  },
}
</script>